<!--
 * @Author: wjc
 * @Date: 2023-11-13 09:38:17
 * @LastEditors: wjc
 * @LastEditTime: 2023-12-11 17:25:31
 * @Description: 
-->
<template>
  <MRow
    v-if="bannerList && bannerList.length > 0"
    :span="24"
    class="banner-container"
    v-bind="rowProps"
  >
    <el-col>
      <el-carousel
        height="180px"
        :indicator-position="isXs ? 'none' : ''"
        :arrow="isXs ? 'always' : 'hover'"
        class="rounded-8px mb-32px"
      >
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <slot name="banner">
            <div class="banner-list">
              <MLink
                :to="item.jumpLink ? item.jumpLink : `/content/post/${item.id}?m=${currentMenu.id}`"
                :target="item.jumpLink ? '_blank' : ''"
              >
                <img :src="item.img" class="w-full h-180px" />
              </MLink>
            </div>
          </slot>
        </el-carousel-item>
      </el-carousel>
    </el-col>
  </MRow>
  <MRow :span="24" justify="start" class="z-1" v-bind="rowProps">
    <el-col class="m-content-container">
      <el-row :gutter="30" class="">
        <el-col v-if="menu && menu.length > 0" :xs="24" :md="6">
          <MContentMenu :data="menu" :current="currentMenu" @click="handleMenuClick"></MContentMenu>
        </el-col>
        <el-col :xs="24" :md="18">
          <div class="bg-white rounded-8px p-24px">
            <div class="title-container">
              <div class="title">{{ currentMenu.name }}</div>
              <MBreadcrumb :list="breadcrumb"></MBreadcrumb>
            </div>
            <div class="content-container">
              <template v-for="item in list" :key="item.id">
                <MLink
                  :to="
                    item.jumpLink ? item.jumpLink : `/content/post/${item.id}?m=${currentMenu.id}`
                  "
                  :target="item.jumpLink ? '_blank' : ''"
                >
                  <MContentItem
                    :text="item.name"
                    :date="item.pushTime"
                    :top="item.top"
                  ></MContentItem>
                </MLink>
              </template>
              <el-empty v-if="list.length === 0 && !loading" description="暂无相关内容" />
              <div v-if="list.length > 0" class="flex-center w-full text-center mt-16px">
                <MPagination
                  :total="pageData.total"
                  :page-size="pageData.pageSize"
                  :current-page="pageData.currentPage"
                  @change="handlePageChange"
                ></MPagination>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </MRow>
</template>

<script setup lang="ts">
  import type { IInfo } from '~/models/activity'
  import type { MRowProps } from '~/components/MRow/index.vue'

  type Banner = {
    id: string
    img: string
    jumpLink?: string
  }

  defineOptions({
    name: 'MContent',
  })

  const props = withDefaults(
    defineProps<{
      loading: boolean
      breadcrumb?: any[]
      list: any[]
      menu?: IInfo[]
      bannerList?: Banner[]
      pageData: PageContent
      rowProps?: MRowProps
    }>(),
    {
      menu: [],
      bannerList: [],
    }
  )
  const emits = defineEmits<{
    (e: 'page', value: number): void
  }>()

  const route = useRoute()
  const currentMenu = ref<IInfo>({})
  const $screen = useScreen()
  const isXs = computed(() => $screen.higherThan('xs'))

  watchEffect(() => {
    const m = props.menu.find((item) => item.id === route.params.id)
    if (m) {
      currentMenu.value = m
    }
  })

  const handleMenuClick = (menu: IInfo) => {
    currentMenu.value = menu
    navigateTo({
      path: `/content/${menu.id}`,
    })
  }

  const handlePageChange = (value: number) => {
    emits('page', value)
  }
</script>

<style scoped lang="scss">
  .m-content-container {
    @apply rounded-8px overflow-hidden;
    .title-container {
      @apply relative flex justify-between items-center pb-24px;
      border-bottom: 2px solid #e5e5e5;
      @screen lt-xs {
        @apply flex-col items-start pb-12px;
        .title {
          @apply mb-12px;
        }
      }
      &::after {
        @apply absolute left-0 bottom--2px inline-block w-120px h-2px bg-bg-color;
        content: '';
      }
      .title {
        @apply relative text-color-1 font-600 font-s-18px pl-12px;
        &::before {
          @apply absolute left-0 top-50% inline-block w-4px h-19px bg-bg-color;
          content: '';
          transform: translate(-50%, -50%);
        }
      }
      .breadcrumb {
        @apply text-color-place font-s-14px;
      }
    }
    .content-container {
      @screen lt-xs {
        @apply overflow-x-auto;
      }
    }
  }
</style>
